import { Avatar } from '@mui/material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_DATE_FORMATE, DEFAULT_LOCAL_PATH } from '../../../constents';
import AppProcessingDropDown from './AppProcessingDropDown';
import AppStatusPopup from './AppStatusPopup';
import PastAppListPopup from './PastAppListPopup';
import PromptDialog from '../../../Utilities/PromptDialog';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import FutureAppListPopup from './FutureAppListPopup';
import CheckEligibilityPopup from './CheckEligibilityPopup';
import { format, isAfter, startOfDay } from 'date-fns';
import SedTeleLinkPopup from './SedTeleLinkPopup';
import RecurrenceModPopup from './RecurrenceModPopup';
import AlertDialog from '../../../Utilities/AlertDialog';
import AppActionDropDown from './AppActionDropDown';
import TakePaymentPopup from './TakePaymentPopUp';
import { useDispatch, useSelector } from 'react-redux';
import {
  handReSchedule,
  setAppPopup,
  setAppPrecurrencePopup,
  setGlobalAppId,
  setPatSrchDiasbled,
} from '../../../redux/slices/scheduler/appointmentSlice';
import { handleGlobalReload } from '../../../redux/slices/appSlice';
import { useAppointmentStatus } from '../../../hooks/useAppointmentStatus';

const AppUnit = ({
  item,
  altClas,
  handleReload,
  appSelectedId,
  setAppSelectedId,
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);

  const [hideShow, setHideShow] = useState(true);
  const [appActHideShow, setAppActHideShow] = useState(true);
  const [statusPopup, setStatusPopup] = useState(false);
  const [pastAppListPopup, setPastAppListPopup] = useState(false);
  const [specAppStatus, setSpecAppStatus] = useState('');
  const [canPromptDialog, setCanPromptDialog] = useState(false);
  const [delPromptDialog, setDelPromptDialog] = useState(false);
  const [noSoPromptDialog, setNoSoPromptDialog] = useState(false);
  const [sucPrams, setSucPrams] = useState({});
  const [handleRescheduledDialig, setHandleRescheduledDialig] = useState(false);
  const [futureAppListPopup, setFutureAppListPopup] = useState(false);
  const [futureAppData, setFutureAppData] = useState('');
  const [checkEligibilityPopup, setCheckEligibilityPopup] = useState(false);
  const [sedTeleLink, setSedTeleLink] = useState({ status: false, data: 0 });
  const { isDialogOpen, checkAppState, closeDialog } = useAppointmentStatus(
    post,
    setUiMessage,
  );
  const [recurrencePopup, setRecurrencePopup] = useState({
    status: false,
    data: null,
    flag: '',
  });
  const [noShowPrompt, setNoShowPrompt] = useState(false);

  const [takePaymentPopup, setTakePaymentPopup] = useState(false);

  const handleAppStatusPopup = () => {
    if (!item?.start_time) return;

    const appointmentDate = startOfDay(new Date(item.start_time));
    const todayStart = startOfDay(new Date()); // Normalizes today to 00:00:00

    // Compare status and check if appointment date is strictly after today
    if (
      item?.appointment_status === '4' &&
      isAfter(appointmentDate, todayStart)
    ) {
      setUiMessage(
        'war',
        "You can't Check-In this patient, because this appointment is on a future date.",
      );
    } else {
      setStatusPopup(true);
      setSpecAppStatus('');
    }
  };

  const handleSpecAppStatusPopup = (status) => {
    setStatusPopup(true);
    setSpecAppStatus(status);
  };

  const handlePastAppList = () => {
    setPastAppListPopup(!pastAppListPopup);
  };

  const handleAppChange = (appId, data) => {
    if (parseInt(data?.recurring_id)) {
      setRecurrencePopup((preVal) => ({
        ...preVal,
        status: true,
        data: data,
        flag: 'change',
      }));
      dispatch(setPatSrchDiasbled(true));
    } else {
      dispatch(setAppPopup(true));
      dispatch(setPatSrchDiasbled(true));
      dispatch(setGlobalAppId(appId));
    }
  };

  const handleAppStatusAct = (flag, appId, appAutoId, data) => {
    if (flag === 'can') {
      if (parseInt(data?.recurring_id)) {
        setRecurrencePopup((preVal) => ({
          ...preVal,
          status: true,
          data: data,
          flag: 'can',
        }));
      } else {
        setCanPromptDialog(true);
      }
      setSucPrams({ appId, appAutoId });
    } else if (flag === 'del') {
      if (parseInt(data?.recurring_id)) {
        setRecurrencePopup((preVal) => ({
          ...preVal,
          status: true,
          data: data,
          flag: 'del',
        }));
      } else {
        setDelPromptDialog(true);
      }
      setSucPrams({ appId, appAutoId });
    } else if (flag === 'noso') {
      if (
        format(new Date(item?.start_time), DEFAULT_DATE_FORMATE) >
        format(new Date(), DEFAULT_DATE_FORMATE)
      ) {
        setNoShowPrompt(true);
      } else {
        setNoSoPromptDialog(true);
      }

      setSucPrams({ appId, appAutoId });
    } else if (flag === 'resch') {
      setHandleRescheduledDialig(true);
      setSucPrams({ appId, appAutoId });
    }
  };

  const handleRecAppStatusAct = (val, data, flag) => {
    const { appointmentId: appId, recurring_id: recurringId } = data;
    if (flag === 'can') {
      setCanPromptDialog(true);
    } else if (flag === 'del') {
      setDelPromptDialog(true);
    } else if (flag === 'change') {
      dispatch(setAppPopup(true));
      dispatch(setGlobalAppId(appId));
      dispatch(
        setAppPrecurrencePopup({
          status: true,
          type: val,
          recurringId: recurringId,
        }),
      );
    }

    setRecurrencePopup({ ...recurrencePopup, status: false });
    setSucPrams({ ...sucPrams, recurringVal: val });
  };

  const handleCancleAppConfirm = async (params) => {
    const { appId, appAutoId, recurringVal, promptVal, chkBoxVal } = params;
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: appId,
          currentStatusId: 2,
          currentStatusAutoIncId: appAutoId,
          patient_id: 0,
          loginUserId: user?.id,
          recurringVal: recurringVal || '0',
          reason: promptVal,
          is_no_show_billed: chkBoxVal,
        },
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Appointment canceled successfully.');
        setCanPromptDialog(false);
        dispatch(handleGlobalReload(!globalReload));
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleDeleteAppConfirm = async (params) => {
    const { appId, appAutoId, recurringVal, promptVal } = params;
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: appId,
          currentStatusId: 10,
          currentStatusAutoIncId: appAutoId,
          patient_id: 0,
          loginUserId: user?.id,
          recurringVal: recurringVal || '0',
          reason: promptVal || '',
        },
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Appointment delete successfully.');
        setDelPromptDialog(false);
        dispatch(handleGlobalReload(!globalReload));
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleNoShowAppConfirm = async (params) => {
    const { appId, appAutoId, chkBoxVal, promptVal } = params;
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: appId,
          currentStatusId: 1,
          currentStatusAutoIncId: appAutoId,
          patient_id: 0,
          loginUserId: user?.id,
          recurringVal: 0,
          reason: promptVal,
          is_no_show_billed: chkBoxVal,
        },
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Appointment no show successfully.');
        setNoSoPromptDialog(false);
        dispatch(handleGlobalReload(!globalReload));
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleRescheduleConfirm = (params) => {
    setHandleRescheduledDialig(false);
    const { appId, appAutoId, promptVal, chkBoxVal } = params;
    dispatch(setAppPopup(true));
    dispatch(setPatSrchDiasbled(true));
    dispatch(setGlobalAppId(appId));

    dispatch(
      handReSchedule({
        status: true,
        text: promptVal,
        appStatusAutoId: appAutoId,
        is_no_show_billed: chkBoxVal,
      }),
    );
  };

  const checkEligibility = () => {
    setCheckEligibilityPopup(!checkEligibilityPopup);
  };

  const callVideoApp = async (appId) => {
    try {
      const response = await post('api/appointment/Appointment/callVideoApp', {
        appointmentId: appId,
        loginId: user?.id,
      });
      if (response?.status === 200) {
        if (response.data?.join_url) {
          const popupOptions = 'width=600,height=400';
          window.open(response.data?.join_url, '_blank', popupOptions);
          handleReload();
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  return (
    <>
      <div
        className={
          item?.appointmentId === appSelectedId
            ? `appt-body-main-rw appointment-highlight `
            : `appt-body-main-rw ${altClas}`
        }
        onClick={() => setAppSelectedId(item?.appointmentId)}
      >
        <div className="appt-body-inr-rw">
          <span
            className="appt-col col-0"
            style={{ backgroundColor: item.location_color }}
          >
            &nbsp;
          </span>
          <div className="appt-col col-1">
            <span className="">
              <Avatar
                alt=""
                src={
                  item.patPhotograph ? item.patPhotograph : './images/user.jpg'
                }
                className="avatar-hover"
              />
            </span>
            <span
              className={item?.reminderStatus?.reminderStClass}
              title={item?.reminderStatus?.reminderStTitle}
            ></span>
          </div>
          <div className="appt-col col-2">
            <Link
              to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item?.user_id}`}
            >
              <span className="name">{item.patient_name}</span>
            </Link>
            <span className="chart-sex">
              ID: {item.chart_number},{' '}
              {item.gender.substring(1, 0).toUpperCase()}
            </span>
            <span className="chart-sex">{item.dobAndAge}</span>
          </div>
          <div className="appt-col col-3">
            <span className="contact">M: {item.mobile}</span>
            <span className="contact">H: {item.home_phone}</span>
            <span className="contact clip-text">{item.email}</span>
          </div>
          <div className="appt-col col-8">
            <span className="qclip-text" title="Medicaid of North Carolina">
              {item.insurance_company_name}
            </span>
            <span className="" onClick={checkEligibility}>
              {/* <Link>{item.insurance_company_name && `Check Eligibility`}</Link> */}
              <Link>
                <img
                  width={'20px'}
                  alt=""
                  src={item?.eligibility?.eliPath}
                  title={item?.eligibility?.eliTitleTxt}
                ></img>
              </Link>
            </span>
          </div>
          <div className="appt-col col-7">
            <span className="">
              {item?.telemedicine === '1' ? (
                <span
                  onClick={() =>
                    setSedTeleLink({
                      ...sedTeleLink,
                      status: true,
                      data: item?.appointmentId,
                    })
                  }
                >
                  📞{' '}
                </span>
              ) : (
                ''
              )}
              <span className="" style={{ float: 'left' }}>
                {item.visit_type}
              </span>
              {parseInt(item?.recurring_id) ? (
                <span
                  className="recur-icon"
                  title={`${item?.occurenceLeft} Occurrence left`}
                >
                  ♽
                </span>
              ) : (
                ''
              )}
            </span>
            <span className="">
              <Link onClick={handlePastAppList}>Appointments</Link>
            </span>
            <span className="hide">Print Enounter</span>
          </div>
          <div className="appt-col col-4">
            <span className="">{item.providerFullName}</span>
            <span onClick={() => setTakePaymentPopup(true)} className="hide">
              {' '}
              {/* {<Link>Take Payment </Link>} */}
              <img src="./images/price.png" alt="Take payment" width="20px" />
            </span>
            <span className="bold hide">09:10 AM</span>
          </div>
          <div className="appt-col col-6">
            <span className="status ">
              <span className="maroon fontsize14">
                {/* {item.display_app_date}
                {' | '}
                {item.app_time}*/}
                {item.display_app_date &&
                  format(new Date(item.display_app_date), 'E, LLL d, yyyy')}
              </span>
              <div
                className=""
                dangerouslySetInnerHTML={{ __html: item?.appStatusColumn }}
              />
            </span>
          </div>
          <div className="appt-col col-10" style={{ position: 'relative' }}>
            <div className="actn-btn">
              {item.appointment_status !== '4' && (
                <span
                  className="actn-btn-arw"
                  onClick={() => setHideShow(!hideShow)}
                >
                  &#9660;
                </span>
              )}
              {item.appointment_status === '4' && (
                <span
                  className="actn-btn-arw"
                  onClick={() => setAppActHideShow(!appActHideShow)}
                >
                  &#9660;
                </span>
              )}

              <span
                className="actn-btn-lbl bold"
                onClick={(() => {
                  if (
                    (parseInt(item.appointment_status) === 9 &&
                      parseInt(item?.create_visit_y_n) === 1) ||
                    (parseInt(item.appointment_status) === 9 &&
                      parseInt(item.treatment_plan_mode) === 1) ||
                    parseInt(item.appointment_status) === 2 ||
                    parseInt(item.appointment_status) === 3 ||
                    parseInt(item.appointment_status) === 1
                  ) {
                    return () => {};
                  } else {
                    return handleAppStatusPopup;
                  }
                })()}
              >
                {item?.currentStatus?.showCurrentStatusOnButton}
              </span>
            </div>
            {(() => {
              if (item?.telemedicine) {
                if (
                  parseInt(item?.nonMeetExpire) === 0 &&
                  parseInt(item?.totalMeetRow) > 0
                ) {
                  return (
                    <div className="allOtherStatusForDashboard cursor">
                      <span
                        className="apch-telemeet-sec left clipText"
                        title={item?.visit_type}
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <span className="apch-telemeet-txt bold">Ended</span>
                        <img
                          src={`${DEFAULT_LOCAL_PATH}/images/telemeet.png`}
                          width="17px"
                          height="17px"
                          alt=""
                        />
                      </span>
                    </div>
                  );
                } else {
                  if (
                    format(new Date(item?.start_time), DEFAULT_DATE_FORMATE) ===
                    format(new Date(), DEFAULT_DATE_FORMATE)
                  ) {
                    if (parseInt(item?.is_meet_start_by_host) === 0) {
                      if (parseInt(item?.meet_part_join_webhook) === 1) {
                        return (
                          <div
                            className="allOtherStatusForDashboard cursor"
                            onClick={() => callVideoApp(item?.appointmentId)}
                          >
                            <span
                              className="apch-telemeet-sec left clipText bg-color-blink"
                              title={item?.visit_type}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <span className="apch-telemeet-txt bold">
                                Start
                              </span>
                              <img
                                src={`${DEFAULT_LOCAL_PATH}/images/telemeet.png`}
                                width="17px"
                                height="17px"
                                alt=""
                              />
                            </span>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            className="allOtherStatusForDashboard cursor"
                            onClick={() => callVideoApp(item?.appointmentId)}
                          >
                            <span
                              className="apch-telemeet-sec clipText"
                              title={item?.visit_type}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <span className="apch-telemeet-txt bold">
                                Start
                              </span>
                              <img
                                src={`${DEFAULT_LOCAL_PATH}/images/telemeet.png`}
                                width="17px"
                                height="17px"
                                alt=""
                              />
                            </span>
                          </div>
                        );
                      }
                    } else if (parseInt(item?.is_meet_start_by_host) === 1) {
                      if (
                        item?.meetUserRow &&
                        parseInt(item?.is_in_meet) === 1
                      ) {
                        return (
                          <div
                            className="allOtherStatusForDashboard cursor"
                            onClick={() => callVideoApp(item?.appointmentId)}
                          >
                            <span
                              className="apch-telemeet-sec clipText"
                              title={item?.visit_type}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <span className="apch-telemeet-txt bold">
                                Joined
                              </span>
                              <img
                                src={`${DEFAULT_LOCAL_PATH}/images/telemeet.png`}
                                width="17px"
                                height="17px"
                                alt=""
                              />
                            </span>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            className="allOtherStatusForDashboard cursor"
                            onClick={() => callVideoApp(item?.appointmentId)}
                          >
                            <span
                              className="apch-telemeet-sec clipText"
                              title={item?.visit_type}
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <span className="apch-telemeet-txt bold">
                                Join
                              </span>
                              <img
                                src={`${DEFAULT_LOCAL_PATH}/images/telemeet.png`}
                                width="17px"
                                height="17px"
                                alt=""
                              />
                            </span>
                          </div>
                        );
                      }
                    }
                  }
                }
              }
            })()}

            <AppProcessingDropDown
              hideShow={hideShow}
              data={item}
              handleSpecAppStatusPopup={handleSpecAppStatusPopup}
              setHideShow={setHideShow}
            />

            <AppActionDropDown
              appActHideShow={appActHideShow}
              setAppActHideShow={setAppActHideShow}
              handleAppChange={() =>
                checkAppState(item?.appointmentId, () =>
                  handleAppChange(item?.appointmentId, item),
                )
              }
              handleAppStatusAct={(type) =>
                checkAppState(item?.appointmentId, () =>
                  handleAppStatusAct(
                    type,
                    item?.appointmentId,
                    item?.appPointmentStatusAutoIncrId,
                    item,
                  ),
                )
              }
              isRecurring={
                item?.recurring_id && parseInt(item?.recurring_id) !== 0
                  ? true
                  : false
              }
            />

            {(() => {
              if (item.appointment_status === '4') {
                return (
                  <>
                    {/* <div className="">
                      <span
                        className="appt-action-links"
                        onClick={() =>
                          handleAppChange(item?.appointmentId, item)
                        }
                      >
                        <Link>Change</Link>
                      </span>
                      |
                      <span
                        className="appt-action-links"
                        onClick={() =>
                          handleAppStatusAct(
                            'del',
                            item?.appointmentId,
                            item?.appPointmentStatusAutoIncrId,
                            item
                          )
                        }
                      >
                        <Link>Delete</Link>
                      </span>
                    </div>
                    <div className="">
                      <span
                        className="appt-action-links"
                        onClick={() =>
                          handleAppStatusAct(
                            'can',
                            item?.appointmentId,
                            item?.appPointmentStatusAutoIncrId,
                            item
                          )
                        }
                      >
                        <Link>Cancel</Link>
                      </span>
                      |
                      <span
                        className="appt-action-links"
                        onClick={() =>
                          handleAppStatusAct(
                            'noso',
                            item?.appointmentId,
                            item?.appPointmentStatusAutoIncrId,
                            item
                          )
                        }
                      >
                        <Link>No Show</Link>
                      </span>
                    </div>
                    <div className="">
                      <span
                        className="appt-action-links"
                        onClick={() =>
                          handleAppStatusAct(
                            'resch',
                            item?.appointmentId,
                            item?.appPointmentStatusAutoIncrId
                          )
                        }
                      >
                        <Link>Reschedule</Link>
                      </span>
                    </div> */}
                  </>
                );
              } else {
                if (
                  item.create_visit_y_n === '1' ||
                  item.treatment_plan_mode === '1'
                ) {
                  return (
                    <div className="actn-btn-links clear-top10">
                      {item?.appointment_status !== '1' &&
                      item?.appointment_status !== '2' &&
                      item?.appointment_status !== '3' ? (
                        <>
                          <span
                            className={`${item?.processStatus?.checkInClass} check-in-stat`}
                            title={item?.processStatus?.stCheckinTitle}
                            onClick={() => handleSpecAppStatusPopup(11)}
                          >
                            {item?.processStatus?.checkInProcessName}
                          </span>
                          {item.treatment_plan_mode === '1' ? (
                            <span
                              className={`${item?.processStatus?.treatmentClass} check-in-stat`}
                              title={item?.processStatus?.stTreatmentTitle}
                              onClick={() => handleSpecAppStatusPopup(5)}
                            >
                              {item?.processStatus?.treatProcessName}
                            </span>
                          ) : (
                            <span
                              className={`${item?.processStatus?.counselClass} check-in-stat`}
                              title={item?.processStatus?.stCounselTitle}
                              onClick={() => handleSpecAppStatusPopup(5)}
                            >
                              {item?.processStatus?.counProcessName}
                            </span>
                          )}

                          <span
                            className={`${item?.processStatus?.checkOutClass} check-in-stat`}
                            title={item?.processStatus?.stcheckOutTitle}
                            onClick={() => handleSpecAppStatusPopup(16)}
                          >
                            {item?.processStatus?.checkOutProcessName}
                          </span>
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div className="actn-btn-links clear-top10">
                      {item?.appointment_status !== '1' &&
                      item?.appointment_status !== '2' ? (
                        <>
                          <span
                            className={`${item?.processStatus?.checkInClass} check-in-stat`}
                            title={item?.processStatus?.stCheckinTitle}
                            onClick={() => handleSpecAppStatusPopup(11)}
                          >
                            {item?.processStatus?.checkInProcessName}
                          </span>
                          <span
                            className={`${item?.processStatus?.screenClass} check-in-stat`}
                            title={item?.processStatus?.stScreenTitle}
                            onClick={() => handleSpecAppStatusPopup(5)}
                          >
                            {item?.processStatus?.screenProcessName}
                          </span>
                          <span
                            className={`${item?.processStatus?.examineClass} check-in-stat`}
                            title={item?.processStatus?.stExamineTitle}
                            onClick={() => handleSpecAppStatusPopup(6)}
                          >
                            {item?.processStatus?.examineProcessName}
                          </span>
                          <span
                            className={`${item?.processStatus?.checkOutClass} check-in-stat`}
                            title={item?.processStatus?.stcheckOutTitle}
                            onClick={() => handleSpecAppStatusPopup(7)}
                          >
                            {item?.processStatus?.checkOutProcessName}
                          </span>
                          <span
                            className={`${item?.processStatus?.pnClass} check-in-stat`}
                            title={item?.processStatus?.stPnTitle}
                            onClick={() => handleSpecAppStatusPopup(9)}
                          >
                            {item?.processStatus?.pnProcessName}
                          </span>
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                  );
                }
              }
            })()}
          </div>
          {statusPopup && (
            <AppStatusPopup
              appId={item?.appointmentId}
              appStatus={specAppStatus || item?.appointment_status}
              typeOfVisit={item?.type_of_visit}
              vCrtOrNot={item?.create_visit_y_n}
              setStatusPopup={setStatusPopup}
              handleReload={handleReload}
              futureApp={() => setFutureAppListPopup(true)}
              futureAppData={setFutureAppData}
              treatment_plan_mode={item.treatment_plan_mode}
            />
          )}
          {pastAppListPopup && (
            <PastAppListPopup
              patientId={item?.user_id}
              setPastAppListPopup={setPastAppListPopup}
            />
          )}
          {checkEligibilityPopup && (
            <CheckEligibilityPopup
              patientId={item?.user_id}
              appId={item?.appointmentId}
              setCheckEligibilityPopup={setCheckEligibilityPopup}
              handleReload={handleReload}
            />
          )}
          {canPromptDialog && (
            <PromptDialog
              title={`${item?.patient_name} (${item?.appointment_type}):`}
              bodytext={`Do you want to Cancel this appointment?`}
              closeDialog={() => setCanPromptDialog(false)}
              successDialog={handleCancleAppConfirm}
              sucPrams={sucPrams}
              chkBoxShow={true}
              chkBoxText={`Bill this Cancelation`}
            />
          )}
          {delPromptDialog && (
            <PromptDialog
              title={`${item?.patient_name} (${item?.appointment_type}):`}
              bodytext={`Do you want to Delete this appointment?`}
              closeDialog={() => setDelPromptDialog(false)}
              successDialog={handleDeleteAppConfirm}
              sucPrams={sucPrams}
            />
          )}
          {noSoPromptDialog && (
            <PromptDialog
              title={`${item?.patient_name} (${item?.appointment_type}):`}
              bodytext={`Do you want to change the status to No Show?`}
              closeDialog={() => setNoSoPromptDialog(false)}
              successDialog={handleNoShowAppConfirm}
              sucPrams={sucPrams}
              chkBoxShow={true}
              chkBoxText={`Do not bill this No Show`}
            />
          )}
          {handleRescheduledDialig && (
            <PromptDialog
              title={`${item?.patient_name} (${item?.appointment_type}):`}
              bodytext={`Do you want to Reschedule this appointment?`}
              closeDialog={() => setHandleRescheduledDialig(false)}
              successDialog={handleRescheduleConfirm}
              sucPrams={sucPrams}
              chkBoxShow={true}
              chkBoxText={`Bill this Reschedule`}
            />
          )}
          {futureAppListPopup && (
            <FutureAppListPopup
              handleClose={() => setFutureAppListPopup(false)}
              futureAppData={futureAppData}
            />
          )}
          {sedTeleLink?.status && (
            <SedTeleLinkPopup
              handleClose={() =>
                setSedTeleLink({ ...sedTeleLink, status: false })
              }
              appId={sedTeleLink?.data}
            />
          )}
          {recurrencePopup?.status && (
            <RecurrenceModPopup
              handleClose={() =>
                setRecurrencePopup({ ...recurrencePopup, status: false })
              }
              data={recurrencePopup?.data}
              flag={recurrencePopup?.flag}
              callback={(val) =>
                handleRecAppStatusAct(
                  val,
                  recurrencePopup?.data,
                  recurrencePopup?.flag,
                )
              }
            />
          )}
          {noShowPrompt && (
            <AlertDialog
              successDialog={() => setNoShowPrompt(false)}
              title={'Message'}
              bodytext={
                "You can't do the No-show process for this appointment because this is in future date"
              }
            />
          )}
          {isDialogOpen && (
            <AlertDialog
              successDialog={() => {
                closeDialog();
                handleReload();
              }}
              title={'Alert'}
              bodytext={'Patient is already checked in.'}
            />
          )}
          {takePaymentPopup && (
            <TakePaymentPopup closePopup={() => setTakePaymentPopup(false)} />
          )}
        </div>
      </div>
    </>
  );
};

export default AppUnit;
